import jwtDecode from 'jwt-decode';
import { getAccessTokenFromStorage, GwscoutJwtPayload } from 'src/stores/Authentication';

export function removeFromArray<T>(arr: Array<T>, item: T): Array<T> {
  return arr.filter((entry) => entry !== item);
}

export function getStage(): 'QA' | 'PROD' | 'DEV' {
  const { hostname } = window.location;
  if (hostname === 'qa-scout.alluc.eu') {
    return 'QA';
  }
  if (hostname === 'scout.alluc.eu') {
    return 'PROD';
  }
  return 'DEV';
}

export function getDefaultWatchlistId(): string {
  const accessToken = getAccessTokenFromStorage();
  const token = jwtDecode<GwscoutJwtPayload>(accessToken ?? '');
  if (token) return `${token.authentication_provider}-${token.user_id}-00000000-0000-0000-0000-000000000000`;
  return '';
}

/**
 * Extracts a short display name from a full model string by stripping the brand prefix
 * and truncating at the first numeric token (e.g. engine displacement, power in kW).
 * Returns at most 3 words. Falls back to the first word if no words remain.
 *
 * e.g. "Volkswagen Golf 2.0 TDI" + "Volkswagen" → "Golf"
 *      "BMW 3 Series 320d xDrive" + "BMW" → "3 Series"
 */
export const extractShortModelName = (fullModel: string, brand: string): string => {
  const withoutBrand = fullModel.replace(new RegExp(`^${brand}\\s+`, 'i'), '');
  const words = withoutBrand.split(' ');
  const modelWords: string[] = [];
  for (const word of words) {
    if (/^\d+(\.\d+)?/.test(word) || /^\d+kW$/.test(word)) break;
    modelWords.push(word);
    if (modelWords.length >= 3) break;
  }
  return modelWords.join(' ') || withoutBrand.split(' ')[0];
};
